/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/documentdataextractor/DocumentDataExtractorScreenTextLocalization.yaml
/**
Configuration of the all strings for document data extractor screen.
*/
export class DocumentDataExtractorScreenTextLocalization {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorScreenTextLocalization>`} */
    constructor(source = {}) {
        /**
          Title for the top bar.
          
          Default is "Document Data Extractor"
          */
        this.topBarTitle = 'Document Data Extractor';
        /**
          Cancel button text for the top bar.
          
          Default is "Cancel"
          */
        this.topBarCancelButton = 'Cancel';
        /**
          Text for the top user guidance caption.
          
          Default is "Point the camera at the ID document"
          */
        this.topUserGuidance = 'Point the camera at the ID document';
        /**
          Title for the introduction screen.
          
          Default is "How to scan an ID document"
          */
        this.introScreenTitle = 'How to scan an ID document';
        /**
          Start scanning button text for the introduction screen.
          
          Default is "Start Scanning"
          */
        this.introScreenDoneButton = 'Start Scanning';
        /**
          The text explanation for the introduction screen.
          
          Default is "To scan an ID, position the document within the frame, ensuring it's properly aligned and all key details are clearly visible. The scanner will then automatically extract essential information like name, date of birth, and document number. Once scanned, the data will be processed.\n\nPress 'Start Scanning' to begin."
          */
        this.introScreenText = "To scan an ID, position the document within the frame, ensuring it's properly aligned and all key details are clearly visible. The scanner will then automatically extract essential information like name, date of birth, and document number. Once scanned, the data will be processed.\n\nPress 'Start Scanning' to begin.";
        /**
          Caption for the success overlay.
          
          Default is "Scanned successfully"
          */
        this.completionOverlaySuccessMessage = 'Scanned successfully';
        /**
          Accessibility description for the 'open introduction screen' button in top bar.
          
          Default is "Open ID document scanning introduction"
          */
        this.accessibilityDescriptionOpenIntroScreenButton = 'Open ID document scanning introduction';
        /**
          Accessibility description for the 'done'/'start scanning' button in the introduction screen.
          
          Default is "Start ID scanning"
          */
        this.accessibilityDescriptionIntroScreenDoneButton = 'Start ID scanning';
        /**
          Accessibility description for the 'cancel' button in the top bar.
          
          Default is "Cancel ID scanning"
          */
        this.accessibilityDescriptionCancelButton = 'Cancel ID scanning';
        /**
          Accessibility description for the retry button in the alerts.
          
          Default is "Retry ID scanning"
          */
        this.accessibilityDescriptionRetryButton = 'Retry ID scanning';
        /**
          Accessibility description for the 'close scanner' button in the alerts.
          
          Default is "Close the scanner"
          */
        this.accessibilityDescriptionCloseScannerButton = 'Close the scanner';
        /**
          Try again button text for the alert.
          
          Default is "Retry"
          */
        this.documentDataExtractorAlertRetryButton = 'Retry';
        /**
          Close Scanner button text for the alert.
          
          Default is "Close Scanner"
          */
        this.documentDataExtractorAlertCloseScannerButton = 'Close Scanner';
        /**
          Title for the alert when no document is detected.
          
          Default is "No document detected"
          */
        this.documentDataExtractorNoDocumentDetectedAlertTitle = 'No document detected';
        /**
          Subtitle for the alert when no document is detected.
          
          Default is "The scanner couldn't detect the document. Please ensure it's well-lit and fully visible, then try again."
          */
        this.documentDataExtractorNoDocumentDetectedAlertSubtitle = "The scanner couldn't detect the document. Please ensure it's well-lit and fully visible, then try again.";
        /**
          Title for the alert when document cannot be processed.
          
          Default is "Document could not be processed"
          */
        this.documentDataExtractorCantProcessDocumentAlertTitle = 'Document could not be processed';
        /**
          Subtitle for the alert when document cannot be processed.
          
          Default is "This document doesn't meet the processing requirements. Please check accepted document types and try again."
          */
        this.documentDataExtractorCantProcessDocumentAlertSubtitle = "This document doesn't meet the processing requirements. Please check accepted document types and try again.";
        /**
          Title for the alert when document is not supported.
          
          Default is "Unsupported document"
          */
        this.documentDataExtractorUnsupportedDocumentAlertTitle = 'Unsupported document';
        /**
          Subtitle for the alert when document is not supported.
          
          Default is "This document type isn't supported. Please try again with a valid document format."
          */
        this.documentDataExtractorUnsupportedDocumentAlertSubtitle = "This document type isn't supported. Please try again with a valid document format.";
        /**
          Title for the alert when scanning takes too long.
          
          Default is "Scanning took too long"
          */
        this.documentDataExtractorScanningTooLongAlertTitle = 'Scanning took too long';
        /**
          Subtitle for the alert when scanning takes too long.
          
          Default is "Scanning took longer than expected. Please ensure the document is well-lit and fully visible, then try again."
          */
        this.documentDataExtractorScanningTooLongAlertSubtitle = 'Scanning took longer than expected. Please ensure the document is well-lit and fully visible, then try again.';
        /**
          Accessibility description for the flash button.
          
          Default is "Toggle flash"
          */
        this.accessibilityDescriptionFlashButton = 'Toggle flash';
        /**
          Accessibility description for the zoom button.
          
          Default is "Toggle camera zoom"
          */
        this.accessibilityDescriptionZoomButton = 'Toggle camera zoom';
        /**
          Accessibility description for the flip camera button.
          
          Default is "Flip camera"
          */
        this.accessibilityDescriptionFlipCameraButton = 'Flip camera';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        /**
          The user guidance text displayed when no document is found.
          
          Default is "Looking for document..."
          */
        this.documentUserGuidanceNoDocumentFound = 'Looking for document...';
        /**
          The user guidance text displayed when a document presence was detected.
          
          Default is "Scanning the document..."
          */
        this.documentUserGuidanceScanningProgress = 'Scanning the document...';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "Too dark. Please turn on a light."
          */
        this.documentUserGuidanceTooDark = 'Too dark. Please turn on a light.';
        /**
          The user guidance text displayed when the detected document is too far away and appears too small.
          
          Default is "Please move closer to the document."
          */
        this.documentUserGuidanceTooSmall = 'Please move closer to the document.';
        /**
          The user guidance text displayed when the detected document is not in a good perspective (device tilted).
          
          Default is "Please hold your device straight over the document."
          */
        this.documentUserGuidanceBadPerspective = 'Please hold your device straight over the document.';
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = source.topBarTitle;
        }
        if (source.topBarCancelButton !== undefined) {
            this.topBarCancelButton = source.topBarCancelButton;
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = source.topUserGuidance;
        }
        if (source.introScreenTitle !== undefined) {
            this.introScreenTitle = source.introScreenTitle;
        }
        if (source.introScreenDoneButton !== undefined) {
            this.introScreenDoneButton = source.introScreenDoneButton;
        }
        if (source.introScreenText !== undefined) {
            this.introScreenText = source.introScreenText;
        }
        if (source.completionOverlaySuccessMessage !== undefined) {
            this.completionOverlaySuccessMessage = source.completionOverlaySuccessMessage;
        }
        if (source.accessibilityDescriptionOpenIntroScreenButton !== undefined) {
            this.accessibilityDescriptionOpenIntroScreenButton = source.accessibilityDescriptionOpenIntroScreenButton;
        }
        if (source.accessibilityDescriptionIntroScreenDoneButton !== undefined) {
            this.accessibilityDescriptionIntroScreenDoneButton = source.accessibilityDescriptionIntroScreenDoneButton;
        }
        if (source.accessibilityDescriptionCancelButton !== undefined) {
            this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
        }
        if (source.accessibilityDescriptionRetryButton !== undefined) {
            this.accessibilityDescriptionRetryButton = source.accessibilityDescriptionRetryButton;
        }
        if (source.accessibilityDescriptionCloseScannerButton !== undefined) {
            this.accessibilityDescriptionCloseScannerButton = source.accessibilityDescriptionCloseScannerButton;
        }
        if (source.documentDataExtractorAlertRetryButton !== undefined) {
            this.documentDataExtractorAlertRetryButton = source.documentDataExtractorAlertRetryButton;
        }
        if (source.documentDataExtractorAlertCloseScannerButton !== undefined) {
            this.documentDataExtractorAlertCloseScannerButton = source.documentDataExtractorAlertCloseScannerButton;
        }
        if (source.documentDataExtractorNoDocumentDetectedAlertTitle !== undefined) {
            this.documentDataExtractorNoDocumentDetectedAlertTitle = source.documentDataExtractorNoDocumentDetectedAlertTitle;
        }
        if (source.documentDataExtractorNoDocumentDetectedAlertSubtitle !== undefined) {
            this.documentDataExtractorNoDocumentDetectedAlertSubtitle =
                source.documentDataExtractorNoDocumentDetectedAlertSubtitle;
        }
        if (source.documentDataExtractorCantProcessDocumentAlertTitle !== undefined) {
            this.documentDataExtractorCantProcessDocumentAlertTitle =
                source.documentDataExtractorCantProcessDocumentAlertTitle;
        }
        if (source.documentDataExtractorCantProcessDocumentAlertSubtitle !== undefined) {
            this.documentDataExtractorCantProcessDocumentAlertSubtitle =
                source.documentDataExtractorCantProcessDocumentAlertSubtitle;
        }
        if (source.documentDataExtractorUnsupportedDocumentAlertTitle !== undefined) {
            this.documentDataExtractorUnsupportedDocumentAlertTitle =
                source.documentDataExtractorUnsupportedDocumentAlertTitle;
        }
        if (source.documentDataExtractorUnsupportedDocumentAlertSubtitle !== undefined) {
            this.documentDataExtractorUnsupportedDocumentAlertSubtitle =
                source.documentDataExtractorUnsupportedDocumentAlertSubtitle;
        }
        if (source.documentDataExtractorScanningTooLongAlertTitle !== undefined) {
            this.documentDataExtractorScanningTooLongAlertTitle = source.documentDataExtractorScanningTooLongAlertTitle;
        }
        if (source.documentDataExtractorScanningTooLongAlertSubtitle !== undefined) {
            this.documentDataExtractorScanningTooLongAlertSubtitle = source.documentDataExtractorScanningTooLongAlertSubtitle;
        }
        if (source.accessibilityDescriptionFlashButton !== undefined) {
            this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
        }
        if (source.accessibilityDescriptionZoomButton !== undefined) {
            this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
        }
        if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
            this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
        if (source.documentUserGuidanceNoDocumentFound !== undefined) {
            this.documentUserGuidanceNoDocumentFound = source.documentUserGuidanceNoDocumentFound;
        }
        if (source.documentUserGuidanceScanningProgress !== undefined) {
            this.documentUserGuidanceScanningProgress = source.documentUserGuidanceScanningProgress;
        }
        if (source.documentUserGuidanceTooDark !== undefined) {
            this.documentUserGuidanceTooDark = source.documentUserGuidanceTooDark;
        }
        if (source.documentUserGuidanceTooSmall !== undefined) {
            this.documentUserGuidanceTooSmall = source.documentUserGuidanceTooSmall;
        }
        if (source.documentUserGuidanceBadPerspective !== undefined) {
            this.documentUserGuidanceBadPerspective = source.documentUserGuidanceBadPerspective;
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorScreenTextLocalization.js.map